export default "__VITE_ASSET__Bsy3iGUo__"